import TjenestepanelCoreCms from '@helsenorge/core-cms/tjenestepanel-v2';
import type {
  AuthenticatedFavoriteTiles,
  AuthenticatedTile,
  AuthenticatedTiles,
  PublicFavoriteTiles,
  PublicTile,
  PublicTiles,
} from '@helsenorge/corefrontend-internalapi-entities/src/helsenorge.corefrontend.internalapi.entities.entities';
import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';

import enResources from '../../resources/HN.CoreFrontend.Web.Forside.en-GB.json';
import nbResources from '../../resources/HN.CoreFrontend.Web.Forside.nb-NO.json';
import seResources from '../../resources/HN.CoreFrontend.Web.Forside.se-NO.json';

interface TjenestepanelResources {
  tjenestepanelVisFlere: string;
  tjenestepanelVisFarre: string;
}

const getResources = (language: 'no' | 'en' | 'se'): TjenestepanelResources => {
  switch (language) {
    case 'no':
      return nbResources;
    case 'en':
      return enResources;
    case 'se':
      return seResources;
    default:
      return nbResources;
  }
};

interface Props {
  language: 'no' | 'en' | 'se';
  favorites: PublicFavoriteTiles[] | null;
  groups: PublicTiles[] | null;
}

const toAuthenticatedTiles = (tiles: PublicTile[] | null): AuthenticatedTile[] | null =>
  tiles?.map(tile => ({ ...tile, highlight: false, visDeltMedBarnet: false })) ?? null;

const Tjenestepanel: React.FunctionComponent<Props> = (props: Props) => {
  const resources = getResources(props.language);
  const favorites: AuthenticatedFavoriteTiles[] | null =
    props.favorites?.map(favorite => ({ ...favorite, tiles: toAuthenticatedTiles(favorite.tiles) })) ?? null;
  const groups: AuthenticatedTiles[] | null = props.groups?.map(group => ({ ...group, tiles: toAuthenticatedTiles(group.tiles) })) ?? null;

  return (
    <TjenestepanelCoreCms
      titleId={getSidetittelId()}
      showMore={resources.tjenestepanelVisFlere}
      showLess={resources.tjenestepanelVisFarre}
      favorites={favorites}
      groups={groups}
    />
  );
};

export default Tjenestepanel;
